"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postorder = postorder;
const dfs_1 = require("./dfs");
function postorder(g, vs) {
    return (0, dfs_1.dfs)(g, vs, 'post');
}
//# sourceMappingURL=postorder.js.map